import { render } from "./topicSelectionList.vue?vue&type=template&id=ade482de"
import script from "./topicSelectionList.vue?vue&type=script&lang=js"
export * from "./topicSelectionList.vue?vue&type=script&lang=js"

import "./topicSelectionList.vue?vue&type=style&index=0&id=ade482de&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__